import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, CheckCircle } from 'lucide-react';

const AGB = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-[#0a0a0a] to-gray-900 py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <Card className="bg-[#111] border-gray-800">
          <CardHeader>
            <div className="flex items-center gap-3 mb-2">
              <FileText className="h-8 w-8 text-blue-500" />
              <CardTitle className="text-3xl text-white">Allgemeine Geschäftsbedingungen (AGB)</CardTitle>
            </div>
            <p className="text-gray-400">
              Für die Nutzung der Software flotto.app von Zonik Solutions
            </p>
          </CardHeader>
          <CardContent className="space-y-8 text-gray-300">
            
            {/* § 1 Geltungsbereich */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 1 Geltungsbereich</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle Verträge zwischen 
                  Zonik Solutions, Friedrichshulder Weg 157A, 25469 Halstenbek (nachfolgend „Anbieter") und dem 
                  Kunden über die Nutzung der webbasierten Software „flotto.app" (nachfolgend „Software").
                </li>
                <li className="leading-relaxed">
                  Abweichende, entgegenstehende oder ergänzende AGB des Kunden werden nicht Vertragsbestandteil, 
                  es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
                </li>
              </ol>
            </section>

            {/* § 2 Vertragsschluss */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 2 Vertragsschluss und Registrierung</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Vertrag kommt durch die Registrierung des Kunden auf der Website flotto.app zustande. 
                  Die Registrierung stellt ein verbindliches Vertragsangebot dar.
                </li>
                <li className="leading-relaxed">
                  Nach erfolgreicher Registrierung erhält der Kunde eine Bestätigungs-E-Mail. Mit dieser E-Mail 
                  nimmt der Anbieter das Angebot an und der Vertrag kommt zustande.
                </li>
                <li className="leading-relaxed">
                  Die kostenlose Testphase beginnt mit der Registrierung und endet automatisch nach 14 Tagen, 
                  sofern der Kunde nicht vorher ein kostenpflichtiges Abonnement abschließt.
                </li>
              </ol>
            </section>

            {/* § 3 Leistungsumfang */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 3 Leistungsumfang</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Anbieter stellt dem Kunden die Software zur webbasierten Nutzung (Software as a Service) 
                  zur Verfügung. Der konkrete Funktionsumfang ergibt sich aus der Leistungsbeschreibung des 
                  gewählten Tarifmodells.
                </li>
                <li className="leading-relaxed">
                  Der Anbieter gewährleistet eine durchschnittliche Verfügbarkeit der Software von 99% im 
                  Jahresmittel. Hiervon ausgenommen sind Wartungsarbeiten sowie Ausfälle, die nicht im 
                  Einflussbereich des Anbieters liegen (höhere Gewalt, Verschulden Dritter etc.).
                </li>
                <li className="leading-relaxed">
                  Der Anbieter ist berechtigt, die Software weiterzuentwickeln und zu verbessern. Wesentliche 
                  Funktionsänderungen werden dem Kunden rechtzeitig mitgeteilt.
                </li>
              </ol>
            </section>

            {/* § 4 Preise und Zahlung */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 4 Preise und Zahlungsbedingungen</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Es gelten die zum Zeitpunkt der Bestellung auf der Website angegebenen Preise. 
                  Alle Preise verstehen sich zzgl. der gesetzlichen Umsatzsteuer.
                </li>
                <li className="leading-relaxed">
                  Die Abrechnung erfolgt monatlich im Voraus. Die Zahlung ist innerhalb von 7 Tagen nach 
                  Rechnungsstellung fällig.
                </li>
                <li className="leading-relaxed">
                  Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in Höhe von 5 Prozentpunkten 
                  über dem Basiszinssatz zu berechnen. Der Anbieter behält sich vor, bei Zahlungsverzug den 
                  Zugang zur Software zu sperren.
                </li>
                <li className="leading-relaxed">
                  Preisänderungen werden dem Kunden mindestens 4 Wochen vor Inkrafttreten mitgeteilt. 
                  Widerspricht der Kunde der Preisänderung nicht innerhalb von 2 Wochen nach Zugang der 
                  Mitteilung, gilt die Preisänderung als genehmigt.
                </li>
              </ol>
            </section>

            {/* § 5 Vertragslaufzeit und Kündigung */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 5 Vertragslaufzeit und Kündigung</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Vertrag läuft auf unbestimmte Zeit. Nach Ablauf der kostenlosen Testphase verlängert sich 
                  der Vertrag automatisch um jeweils einen Monat, sofern er nicht gekündigt wird.
                </li>
                <li className="leading-relaxed">
                  Beide Parteien können den Vertrag mit einer Frist von einem Monat zum Monatsende kündigen. 
                  Die Kündigung bedarf der Textform (z.B. E-Mail).
                </li>
                <li className="leading-relaxed">
                  Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. Ein wichtiger 
                  Grund liegt für den Anbieter insbesondere vor bei:
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>Zahlungsverzug von mehr als 2 Monaten</li>
                    <li>Verstoß gegen die Nutzungsbedingungen trotz Abmahnung</li>
                    <li>Insolvenz des Kunden</li>
                  </ul>
                </li>
              </ol>
            </section>

            {/* § 6 Nutzungsrechte */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 6 Nutzungsrechte und Lizenz</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Kunde erhält ein nicht-ausschließliches, nicht übertragbares Nutzungsrecht an der Software 
                  für die Dauer der Vertragslaufzeit.
                </li>
                <li className="leading-relaxed">
                  Die Nutzung der Software ist auf die im gewählten Tarif vereinbarte Anzahl von Fahrzeugen 
                  und Benutzern beschränkt.
                </li>
                <li className="leading-relaxed">
                  Eine Weitergabe der Zugangsdaten an Dritte ist untersagt. Der Kunde ist verpflichtet, seine 
                  Zugangsdaten geheim zu halten und vor dem Zugriff Dritter zu schützen.
                </li>
                <li className="leading-relaxed">
                  Alle Rechte an der Software, einschließlich etwaiger Schutzrechte, verbleiben beim Anbieter. 
                  Eine Vervielfältigung, Bearbeitung oder sonstige Verwertung der Software ist nicht gestattet.
                </li>
              </ol>
            </section>

            {/* § 7 Pflichten des Kunden */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 7 Pflichten des Kunden</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Kunde ist verpflichtet, die Software nur im Rahmen der gesetzlichen Bestimmungen und 
                  dieser AGB zu nutzen.
                </li>
                <li className="leading-relaxed">
                  Der Kunde verpflichtet sich, keine Inhalte einzustellen oder zu übermitteln, die:
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                    <li>gegen geltendes Recht verstoßen</li>
                    <li>Rechte Dritter (insbesondere Urheber-, Marken- oder Persönlichkeitsrechte) verletzen</li>
                    <li>schädliche Software (Viren, Trojaner etc.) enthalten</li>
                  </ul>
                </li>
                <li className="leading-relaxed">
                  Der Kunde ist für die Sicherung seiner Daten selbst verantwortlich. Der Anbieter empfiehlt 
                  regelmäßige Backups.
                </li>
              </ol>
            </section>

            {/* § 8 Gewährleistung */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 8 Gewährleistung</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Anbieter gewährleistet, dass die Software im Wesentlichen die in der Leistungsbeschreibung 
                  angegebenen Funktionen aufweist.
                </li>
                <li className="leading-relaxed">
                  Mängel wird der Anbieter innerhalb angemessener Frist nach Mängelanzeige durch Nachbesserung 
                  oder Ersatzlieferung beseitigen. Der Kunde ist verpflichtet, Mängel unverzüglich anzuzeigen.
                </li>
                <li className="leading-relaxed">
                  Schlägt die Nachbesserung zweimal fehl, kann der Kunde nach seiner Wahl Minderung verlangen 
                  oder vom Vertrag zurücktreten.
                </li>
              </ol>
            </section>

            {/* § 9 Haftung */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 9 Haftung</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Anbieter haftet uneingeschränkt für Vorsatz und grobe Fahrlässigkeit sowie nach den 
                  Vorschriften des Produkthaftungsgesetzes.
                </li>
                <li className="leading-relaxed">
                  Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten haftet der Anbieter der 
                  Höhe nach begrenzt auf den vertragstypischen, vorhersehbaren Schaden. Wesentliche 
                  Vertragspflichten sind solche, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags 
                  überhaupt erst ermöglicht.
                </li>
                <li className="leading-relaxed">
                  Im Übrigen ist die Haftung des Anbieters ausgeschlossen, soweit gesetzlich zulässig.
                </li>
                <li className="leading-relaxed">
                  Die vorstehenden Haftungsbeschränkungen gelten auch zugunsten der Mitarbeiter und 
                  Erfüllungsgehilfen des Anbieters.
                </li>
              </ol>
            </section>

            {/* § 10 Datenschutz */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 10 Datenschutz</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Der Anbieter verarbeitet personenbezogene Daten des Kunden im Rahmen der gesetzlichen 
                  Bestimmungen, insbesondere der DSGVO.
                </li>
                <li className="leading-relaxed">
                  Einzelheiten ergeben sich aus der Datenschutzerklärung, die unter 
                  <a href="/datenschutz" className="text-blue-400 hover:text-blue-300 ml-1">
                    flotto.app/datenschutz
                  </a> abrufbar ist.
                </li>
                <li className="leading-relaxed">
                  Der Kunde ist verpflichtet, bei der Eingabe personenbezogener Daten Dritter (z.B. Mitarbeiter) 
                  die datenschutzrechtlichen Bestimmungen einzuhalten.
                </li>
              </ol>
            </section>

            {/* § 11 Schlussbestimmungen */}
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">§ 11 Schlussbestimmungen</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li className="leading-relaxed">
                  Änderungen und Ergänzungen dieser AGB bedürfen der Textform (z.B. E-Mail).
                </li>
                <li className="leading-relaxed">
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit 
                  der übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung tritt eine 
                  wirksame Regelung, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
                </li>
                <li className="leading-relaxed">
                  Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                </li>
                <li className="leading-relaxed">
                  Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag 
                  ist der Sitz des Anbieters, sofern der Kunde Kaufmann, juristische Person des öffentlichen 
                  Rechts oder öffentlich-rechtliches Sondervermögen ist.
                </li>
              </ol>
            </section>

            {/* Summary Box */}
            <div className="p-6 bg-gradient-to-r from-blue-900/20 to-purple-900/20 border border-blue-800/50 rounded-lg">
              <h3 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                <CheckCircle className="h-6 w-6 text-green-500" />
                Ihre Vorteile auf einen Blick
              </h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                  <span>14 Tage kostenlos testen - keine Kreditkarte erforderlich</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                  <span>Monatlich kündbar - keine Mindestlaufzeit</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                  <span>Transparente Preise - keine versteckten Kosten</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                  <span>DSGVO-konform - Ihre Daten sind sicher</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
                  <span>Deutscher Support - Wir sprechen Ihre Sprache</span>
                </li>
              </ul>
            </div>

            <div className="pt-8 border-t border-gray-800 text-sm text-gray-500">
              <p>Stand: Dezember 2025</p>
              <p className="mt-2">
                Bei Fragen zu den AGB kontaktieren Sie uns unter: 
                <a href="mailto:Admin@zonik-solutions.de" className="text-blue-400 hover:text-blue-300 ml-2">
                  Admin@zonik-solutions.de
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AGB;
